import { create } from 'zustand';
import {
  CreateExhibitionBulkResult,
  ExhibitionData,
  SimpleExhibitionData,
} from '../../../shared/dto/EntityRepository';
import { CreateExhibitionBulkItemReq } from '../../../shared/dto/ReqDtoRepository';
import { PerPage } from '../../../shared/enum/EnumRepository';

interface AdminExhibitionState {
  exhibitionList: SimpleExhibitionData[];
  activeExhibition: ExhibitionData | null;
  multiSelectedExhibitionIds: number[];
  bulkResult: CreateExhibitionBulkResult | null;
  bulkItems: CreateExhibitionBulkItemReq[];
  isBulkPreviewOpen: boolean;
  hasChanged: boolean;
  page: number;
  totalPages: number;
  pageSize: PerPage;
  setExhibitionList: (exhibitionList: SimpleExhibitionData[]) => void;
  setActiveExhibition: (activeExhibition: ExhibitionData | null) => void;
  setMultiExhibitionSelection: (exhibitionIds: number[]) => void;
  clearExhibitionSelection: () => void;
  setBulkResult: (bulkResult: CreateExhibitionBulkResult | null) => void;
  setBulkItems: (bulkItems: CreateExhibitionBulkItemReq[]) => void;
  setIsBulkPreviewOpen: (isBulkPreviewOpen: boolean) => void;
  setHasChanged: (hasChanged: boolean) => void;
  setPagination: (page: number, totalPages: number) => void;
  setPageSize: (pageSize: PerPage) => void;
}

export const useAdminExhibitionStore = create<AdminExhibitionState>((set) => ({
  exhibitionList: [],
  activeExhibition: null,
  multiSelectedExhibitionIds: [],
  bulkResult: null,
  bulkItems: [],
  isBulkPreviewOpen: false,
  hasChanged: false,
  page: 1,
  totalPages: 0,
  pageSize: PerPage.PAGE_20,
  setExhibitionList: (exhibitionList) => set({ exhibitionList }),
  setActiveExhibition: (activeExhibition) => set({
    activeExhibition,
    multiSelectedExhibitionIds: [],
  }),
  setMultiExhibitionSelection: (multiSelectedExhibitionIds) => set({
    activeExhibition: null,
    multiSelectedExhibitionIds,
    hasChanged: false,
  }),
  clearExhibitionSelection: () => set({
    activeExhibition: null,
    multiSelectedExhibitionIds: [],
    hasChanged: false,
  }),
  setBulkResult: (bulkResult) => set({ bulkResult }),
  setBulkItems: (bulkItems) => set({ bulkItems }),
  setIsBulkPreviewOpen: (isBulkPreviewOpen) => set({ isBulkPreviewOpen }),
  setHasChanged: (hasChanged) => set({ hasChanged }),
  setPagination: (page, totalPages) => set({ page, totalPages }),
  setPageSize: (pageSize) => set({ pageSize }),
}));
